export default "__VITE_ASSET__f225f26a__"